<template>
  <div class="box-align-center box-pack-between main">
    <el-button icon="el-icon-arrow-left" type="text" @click="goBack">返回</el-button>
    <div class="whiteBg" style="padding: 20px 0 0">
      <el-tabs v-model="activeName" :tab-position="tabPosition" :before-leave="beforeTabLeave">
        <el-tab-pane label="单选题" name="1" :disabled="type == 'edit'">
          <singleChoiceQuestion ref="single"></singleChoiceQuestion>
        </el-tab-pane>
        <el-tab-pane label="多选题" name="2" :disabled="type == 'edit'">
          <multipleChoiceQuestions ref="multip"></multipleChoiceQuestions>
        </el-tab-pane>
        <el-tab-pane label="判断题" name="3" :disabled="type == 'edit'">
          <tureOrFalseQuestions ref="torf"></tureOrFalseQuestions>
        </el-tab-pane>
        <el-tab-pane label="填空题" name="4" :disabled="type == 'edit'">
          <blanksQuestions ref="blanks"></blanksQuestions>
        </el-tab-pane>
        <el-tab-pane label="主观题" name="5" :disabled="type == 'edit'">
          <subjectiveQuestions ref="subjective"></subjectiveQuestions>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import singleChoiceQuestion from './components/singleChoiceQuestion.vue';
import subjectiveQuestions from './components/subjectiveQuestions.vue';
import blanksQuestions from './components/blanksQuestions.vue';
import multipleChoiceQuestions from './components/multipleChoiceQuestions.vue';
import tureOrFalseQuestions from './components/tureOrFalseQuestions.vue';

var that = null;
export default {
  components: {
    singleChoiceQuestion,
    subjectiveQuestions,
    blanksQuestions,
    multipleChoiceQuestions,
    tureOrFalseQuestions,
  },
  data() {
    return {
      tabPosition: 'left',
      activeName: '1',
      type: '',
      isDirty: false,
    };
  },
  mounted() {
    that = this;
    this.activeName = this.$route.query.topicType ? this.$route.query.topicType : '1';
    this.type = this.$route.query.type;
  },
  methods: {
    async beforeTabLeave() {
      if (this.activeName == '1') {
        const obj = this.$refs.single.ruleForm;
        const list = this.$refs.single.labelNameList;
        if (obj.stem && obj.categoryId && list.length > 0) {
          await this.getConfirm();
        }
      } else if (this.activeName == '2') {
        const obj = this.$refs.multip.ruleForm;
        const list = this.$refs.multip.labelNameList;
        if (obj.stem && obj.categoryId && list.length > 0) {
          await this.getConfirm();
        }
      } else if (this.activeName == '3') {
        const obj = this.$refs.torf.ruleForm;
        const list = this.$refs.torf.labelNameList;
        if (obj.stem && obj.categoryId && list.length > 0) {
          await this.getConfirm();
        }
      } else if (this.activeName == '4') {
        const obj = this.$refs.blanks.ruleForm;
        const list = this.$refs.blanks.labelNameList;
        if (obj.stem && obj.categoryId && list.length > 0) {
          await this.getConfirm();
        }
      } else if (this.activeName == '5') {
        const obj = this.$refs.subjective.ruleForm;
        const list = this.$refs.subjective.labelNameList;
        if (obj.stem && obj.categoryId && list.length > 0) {
          await this.getConfirm();
        }
      }
    },
    getConfirm() {
      return new Promise((resolve, reject) => {
        // this.$confirm('您创建的试题还未进行录入操作，是否进行录入操作后再切换标签页？', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning',
        // })
        //   .then(() => {
        //     reject(false); // 不允许切换标签页，保持在当前页面
        //   })
        //   .catch(() => {
        //     resolve(true); // 允许切换标签页
        //   });
        this.$message.warning('您创建的试题还未进行录入操作，请进行录入操作后再切换标签页');
        return;
      });
    },
    goBack() {
      this.$router.push('./questionList');
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-submenu .el-menu-item {
  min-width: initial;
}
.main {
  padding: 12px;

  .main-left {
    flex-shrink: 0;
    width: 180px;
  }

  .main-right {
    flex: 1;
  }
}
</style>
